// Local storage keys for the application
export const LAST_USERNAME_KEY = "aionify_last_username";
export const TOKEN_KEY = "aionify_token";
export const LANGUAGE_KEY = "aionify_language";
